import React, {FC} from 'react';

/** Русский текст вкладки «Генерация главных/детальных изображений» руководства пользователя, структура элементов 1:1 соответствует zh.tsx. 2026-09-17 AI-перевод. */
const RuContent: FC = () => {
  return (
    <>
      <h2>Генерация главных и детальных изображений</h2>
      <p>
        Без промптов — загрузите фото товара или вставьте ссылку на товар, и ИИ сгенерирует главные изображения,
        дополнительные изображения и полные комплекты детальных изображений, соответствующие требованиям площадок, —
        включая Amazon, Ozon, Coupang, Rakuten, Temu и другие крупные платформы.
      </p>

      <h3>1. Загрузите фото товара или вставьте ссылку на товар</h3>
      <p>
        Поддерживаются два способа загрузки: загрузите напрямую реальное фото товара или изображение на белом фоне либо
        вставьте ссылку на товар — система автоматически захватит главное изображение в качестве исходника для
        генерации.
      </p>

      <h3>2. ИИ распознаёт товар и создаёт изображения</h3>
      <p>
        ИИ автоматически распознаёт товар, выстраивает сцену и извлекает продающие пункты, чтобы создать главные и
        детальные изображения, соответствующие требованиям выбранной вами площадки, — у каждого типа изображений своя
        задача:
      </p>
      <ul>
        <li>
          Главные изображения заставляют покупателей «остановиться»: они быстро формируют первое впечатление в поиске,
          рекомендациях и на странице товара, решая, кликнет ли покупатель внутрь.
        </li>
        <li>
          Детальные изображения заставляют покупателей «остаться»: через продающие пункты, сценарии использования и
          повышение доверия они устраняют сомнения и подводят покупателя к покупке.
        </li>
      </ul>

      <h3>3. Выберите визуальный стиль для целевого рынка</h3>
      <p>Доступно пять встроенных рыночных стилей — вам не придётся самостоятельно угадывать местную эстетику:</p>
      <ul>
        <li>
          Северная Америка/Европа (Amazon): брендовость, рациональность, премиальный образ жизни — сдержанная вёрстка,
          качественные фото, чёткая информационная иерархия.
        </li>
        <li>
          Япония: эмоциональная описательность, высокая убедительность — яркие заголовки и слоганы, насыщенная, но чётко
          организованная информация.
        </li>
        <li>
          Корея (Coupang): ориентация на образ жизни, мягкость и близость к покупателю — выраженные сцены, сдержанный
          текст, нежное настроение.
        </li>
        <li>
          Россия (Ozon): сильная нацеленность на конверсию, прямое убеждение — жирные заголовки, крупные цветовые блоки,
          плотные пиктограммы-подписи.
        </li>
        <li>
          Юго-Восточная Азия: выраженный промо-характер, визуальный маркетинг — яркие цвета, чёткая акционная атмосфера.
        </li>
      </ul>

      <h3>4. Предпросмотр перед генерацией версии в высоком разрешении</h3>
      <p>
        Сначала посмотрите результат в предпросмотре — он стоит всего <strong>0,4 юаня за набор</strong>. Когда
        результат вас устроит, сгенерируйте полный комплект в высоком разрешении, чтобы не расходовать кредиты впустую.
      </p>

      <h3>5. Скачайте и используйте</h3>
      <p>
        Когда генерация завершится, скачайте все изображения напрямую и загрузите их в поля главного изображения и
        детальной страницы вашей площадки.
      </p>
    </>
  );
};

export default RuContent;
